import { baseUrl } from '../../../network'

export const profileEditResourceUrl = baseUrl + '/api/profile'
export const getUserProfileUrl = (userId: number)=> baseUrl + `/api/users/${userId}`
export const profileUpdateStatusResourceUrl = baseUrl + '/api/profile/updateStatus'
export const profileEditUserAvatarResourceUrl = baseUrl + '/api/profile/avatar'
export const profileManageNotificationUrl = (notificationId: number)=> baseUrl + `/api/profile/notifications/${notificationId}`
export const profileGetNotificationsUrl = baseUrl + '/api/profile/notifications'
